assert.equal( ANSWER, 42 );
